import React, { useEffect, useState } from 'react';

const getRandomLetter = () => {
  //const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ★☆✿❀✓✦☀☁☂☘✧❖♣♦♥♠✶✹✺☯☮☘'.split('');

  return letters[Math.floor(Math.random() * letters.length)];
};

const AlphabetBackground = () => {
  const [letters, setLetters] = useState([]);

  useEffect(() => {
    const count = 300; // Number of letters
    const generated = Array.from({ length: count }).map(() => ({
      id: Math.random(),
      char: getRandomLetter(),
      top: `${Math.random() * 100}%`,
      left: `${Math.random() * 100}%`,
      delay: `${Math.random() * 5}s`,
      size: `${16 + Math.random() * 24}px`,
    }));
    setLetters(generated);
  }, []);

  return (
    <div className="alphabet-bg">
      {letters.map((l) => (
        <span
          key={l.id}
          style={{
            position: 'absolute',
            top: l.top,
            left: l.left,
            fontSize: l.size,
            fontWeight: 'bold',
            color: 'rgba(0, 0, 0, 0.09)',
            animation: 'fadeZoom 4s ease-in-out infinite',
            animationDelay: l.delay,
            pointerEvents: 'none',
            userSelect: 'none',
          }}
        >
          {l.char}
        </span>
      ))}
    </div>
  );
};

export default AlphabetBackground;
